// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGAdd = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#add__clip0_12_2789)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "add__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#add__clip1_12_2789)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M28.8571 15.1428H17.4286V3.71427C17.4286 3.0857 16.9143 2.57141 16.2857 2.57141C15.6571 2.57141 15.1428 3.0857 15.1428 3.71427V15.1428H3.71427C3.0857 15.1428 2.57141 15.6571 2.57141 16.2857C2.57141 16.9143 3.0857 17.4286 3.71427 17.4286H15.1428V28.8571C15.1428 29.4857 15.6571 30 16.2857 30C16.9143 30 17.4286 29.4857 17.4286 28.8571V17.4286H28.8571C29.4857 17.4286 30 16.9143 30 16.2857C30 15.6571 29.4857 15.1428 28.8571 15.1428Z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#add__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "add__clip0_12_2789",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "add__clip1_12_2789",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGAdd.displayName = 'SVGAdd';
export default SVGAdd;